import * as React from 'react';
import {useContext, useState} from 'react';
import {DefaultButton, Dialog, DialogFooter, DialogType, IconButton, PrimaryButton} from '@fluentui/react';
import AuthContext from "../Services/AuthContext";

function DeleteConfirmation(props) {
    const [user] = useContext(AuthContext);
    const [dialog, setDialog] = useState(false);

    const dialogContentProps = {
        type: DialogType.normal,
        title: props.title,
        closeButtonAriaLabel: 'Zamknij',
        subText: props.subtitle,
    };

    const _submit = (e) => {
        e.preventDefault();
        fetch(`${props.url}/${props.id}`, {
            method: 'DELETE',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(json => {
                setDialog(false);
                props.onSuccess();
            })
            .catch(err => {
                console.log(err)
            })
    }

    return (<div>
        <IconButton iconProps={{iconName: 'trash'}} onClick={() => setDialog(true)} />
        <Dialog
            hidden={!dialog}
            onDismiss={() => setDialog(false)}
            dialogContentProps={dialogContentProps}
        >
            <DialogFooter>
                <PrimaryButton onClick={_submit} text="Usuń"/>
                <DefaultButton onClick={() => setDialog(false)} text="Anuluj"/>
            </DialogFooter>
        </Dialog></div>
    )
}

export default DeleteConfirmation;